import { render, staticRenderFns } from "./ContractsPage.vue?vue&type=template&id=7d246e74&"
import script from "./ContractsPage.vue?vue&type=script&lang=js&"
export * from "./ContractsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports